import { useEffect } from 'react';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import TextField from '@mui/material/TextField';
import { onProjectSelected } from './harnessProjectBus';

export const HarnessAutoOrgPicker = ({
  onChange,
  formData,
  schema,
}: FieldExtensionComponentProps<string>) => {
  useEffect(() => {
    return onProjectSelected(orgId => {
      onChange(orgId);
    });
  }, [onChange]);

  return (
    <TextField
      fullWidth
      label={schema.title ?? 'Organisation'}
      value={formData ?? ''}
      InputProps={{ readOnly: true }}
      InputLabelProps={{ shrink: true }}
      helperText="Auto-populated from selected project"
    />
  );
};
